/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchAndSavePreviewImagesForItineraryRequest
 */
export interface SearchAndSavePreviewImagesForItineraryRequest {
    /**
     * Number of images to search and save (default: 5, max: 20)
     * @type {number}
     * @memberof SearchAndSavePreviewImagesForItineraryRequest
     */
    count?: number;
}

/**
 * Check if a given object implements the SearchAndSavePreviewImagesForItineraryRequest interface.
 */
export function instanceOfSearchAndSavePreviewImagesForItineraryRequest(value: object): value is SearchAndSavePreviewImagesForItineraryRequest {
    return true;
}

export function SearchAndSavePreviewImagesForItineraryRequestFromJSON(json: any): SearchAndSavePreviewImagesForItineraryRequest {
    return SearchAndSavePreviewImagesForItineraryRequestFromJSONTyped(json, false);
}

export function SearchAndSavePreviewImagesForItineraryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAndSavePreviewImagesForItineraryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

  export function SearchAndSavePreviewImagesForItineraryRequestToJSON(json: any): SearchAndSavePreviewImagesForItineraryRequest {
      return SearchAndSavePreviewImagesForItineraryRequestToJSONTyped(json, false);
  }

  export function SearchAndSavePreviewImagesForItineraryRequestToJSONTyped(value?: SearchAndSavePreviewImagesForItineraryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

